/**
 * FullPageLoader.js
 * @author Ivan Žarković
 * @date 11-04-2025
 * @version 0.0.1
 * @description Ova komponenta koristi Redux za upravljanje stanjem učitavanja. Kada je učitavanje aktivno, prikazuje se maska preko cele stranice.
 * @documentation obsidian://open?vault=Dokumentacija&file=FRONT%20dokumentacija%2FB2B%2FGlobalni%20loader
 */

import React from 'react';
import { useSelector } from 'react-redux';

const FullPageLoader = () => {
    const isLoading = useSelector((state) => state.loader.isLoading); // Globalni loader state

    if (!isLoading) return null; // Ako nije aktivan, ne renderuj ništa

    return (
        <div className="loader-mask-wrapper">
            <div className="loader-mask">
                {/* Stilizovan u CSS-u */}
            </div>
        </div>
    );
};

export default FullPageLoader;